import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible'
  },
  cardContent: {
    height: 'auto',
    padding: theme.spacing(2)
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    padding: '0rem 1rem',
    minHeight: '3rem',
    '.MuiCardHeader-title': {
      fontWeight: 600,
      fontSize: '1rem'
    },
    '& > .MuiCardHeader-content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  cardActions: {
    padding: '0.75rem 1rem',
    justifyContent: 'flex-end',
    borderTop: `1px solid ${theme.vars.palette.divider}`
  }
}));

export default useStyles;
